import { useRouteLoaderData } from "react-router-dom";
import { Trash2 } from "lucide-react";

import { ClientForm } from "@/components/ClientForm";
import { UPDATE_CLIENT_ROUTE_ID } from "@/router";
import { ClientInvoicesTable } from "@/components/tables/ClientInvoicesTable";
import { Button } from "@/components/ui/button";
import { ClientDeleteButton } from "@/components/ClientDeleteButton";

interface ClientLoaderData {
  id: number;
  name: string;
  contact_name: string;
  code: string;
  vat: string;
  phone: string;
  address: string;
  contract_id: string;
  tenant_id: number;
  type: string;
}

export function UpdateClient(): React.JSX.Element {
  const data = useRouteLoaderData(UPDATE_CLIENT_ROUTE_ID) as ClientLoaderData;

  return (
    <div className="space-y-8">
      <div>
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold">Kliento informacija</h1>
          <ClientDeleteButton client={data}>
            <Button variant="destructive" className="flex items-center gap-2">
              <Trash2 className="h-4 w-4" />
              Ištrinti klientą
            </Button>
          </ClientDeleteButton>
        </div>
        <ClientForm {...data} />
      </div>

      <div className="pt-4 border-t">
        <ClientInvoicesTable clientId={data.id} />
      </div>
    </div>
  );
}
